module.exports = __webpack_public_path__ + "img/win-icon4.655a4a8.png";